import i18next from 'i18next';
import { tableDataParser } from './tableDataParser';

const customSortName = (rowA, rowB, accessor) => {
  const a = rowA.original[accessor].props.name;
  const b = rowB.original[accessor].props.name;
  return a > b ? 1 : -1;
};

const customSort = (rowA, rowB, accessor) => {
  const a = parseInt(rowA.original[accessor].props.name, 10);
  const b = parseInt(rowB.original[accessor].props.name, 10);
  return a > b ? 1 : -1;
};

const columns = () => [
  {
    Header: i18next.t('namePosition'),
    accessor: 'namePosition',
    sortType: (a, b) => customSortName(a, b, 'namePosition'),
  },
  {
    Header: i18next.t('goalsNoKey'),
    accessor: 'goals',
    sortType: (a, b) => customSort(a, b, 'goals'),
  },
  {
    Header: i18next.t('passes'),
    accessor: 'passes',
    sortType: (a, b) => customSort(a, b, 'passes'),
  },
  {
    Header: i18next.t('recoveries'),
    accessor: 'recoveries',
    sortType: (a, b) => customSort(a, b, 'recoveries'),
  },
  {
    Header: i18next.t('shotsNoKey'),
    accessor: 'shotsStops',
    sortType: (a, b) => customSort(a, b, 'shotsStops'),
  },
  {
    Header: i18next.t('assists'),
    accessor: 'assists',
    sortType: (a, b) => customSort(a, b, 'assists'),
  },
  {
    Header: i18next.t('stops'),
    accessor: 'stops',
    sortType: (a, b) => customSort(a, b, 'stops'),
  },
  {
    Header: i18next.t('games'),
    accessor: 'gamesPlayed',
    sortType: (a, b) => customSort(a, b, 'gamesPlayed'),
  },
];

const visitorColumns = () => [
  {
    Header: i18next.t('goalsNoKey'),
    accessor: 'goals',
    sortType: (a, b) => customSort(a, b, 'goals'),
  },
  {
    Header: i18next.t('passes'),
    accessor: 'passes',
    sortType: (a, b) => customSort(a, b, 'passes'),
  },
  {
    Header: i18next.t('recoveries'),
    accessor: 'recoveries',
    sortType: (a, b) => customSort(a, b, 'recoveries'),
  },
  {
    Header: i18next.t('shotsNoKey'),
    accessor: 'shotsStops',
    sortType: (a, b) => customSort(a, b, 'shotsStops'),
  },
  {
    Header: i18next.t('assists'),
    accessor: 'assists',
    sortType: (a, b) => customSort(a, b, 'assists'),
  },
  {
    Header: i18next.t('stops'),
    accessor: 'stops',
    sortType: (a, b) => customSort(a, b, 'stops'),
  },
  {
    Header: i18next.t('games'),
    accessor: 'gamesPlayed',
    sortType: (a, b) => customSort(a, b, 'gamesPlayed'),
  },
  {
    Header: i18next.t('namePosition'),
    accessor: 'namePosition',
    sortType: (a, b) => customSortName(a, b, 'namePosition'),
  },
];

export { columns, visitorColumns, tableDataParser };
